
import store from "~/store";

function page(path) {
    return () =>
        import(/* webpackChunkName: '' */ `~/pages/${path}`).then(
            m => m.default || m
        );
}



export default [


    /**
     * Routes Guest Leadgrease
     */
    { path: '/', redirect: to => `/${store.getters["lang/locale"]}` },
    { path: "/:lang", name: "welcome", component: page("welcome.vue"), props: true },

    { path: "/:lang/login", name: "login", component: page("auth/login.vue"), props: true },
    { path: "/:lang/register", name: "register", component: page("auth/register.vue"), props: true },
    { path: "/:lang/activeAccount/:email", name: "active_account", component: page("auth/active-account.vue"), props: true },
    { path: "/:lang/activeAccount/:code/:email", name: "active_account", component: page("auth/active-account.vue"), props: true },

    { path: "/:lang/password/reset", name: "password.request", component: page("auth/password/email.vue") },
    { path: "/:lang/password/confirm-reset-password/:email", name: "confirm_reset_password", component: page("auth/password/confirm_reset_password.vue") },


    /**
     * Routes App Leadgrease
     */
    { path: "/app/dashboard", name: "dashboard", component: page("app/dashboard/dashboard.vue") },
    { path: "/app/test/components", name: "test_components", component: page("app/Tests/TestComponents.vue") },

    { path: "/app/inputs/imports/import", name: "import", component: page("app/inputs/imports/import_config.vue") },
    { path: "/app/inputs/imports", name: "imports", component: page("app/inputs/imports/imports.vue") },
    { path: "/app/inputs/imports/logs", name: "import_logs", component: page("app/inputs/imports/import_logs.vue") },
    { 
        path: "/app/inputs/integrations", 
        name: "3th_party_connections", 
        component: page("app/inputs/Integrations/Main.vue"),
        meta: {
            title: "3th party connections"
        }
    },
    { path: "/app/inputs/integrations/add", name: "add_provider_integration", component: page("app/inputs/Integrations/View.vue") },
    { path: "/app/inputs/integrations/:uuid/edit", name: "edit_provider_integration", component: page("app/inputs/Integrations/View.vue") },
    { 
        path: "/app/inputs/integrations/:uuid/logs", 
        name: "3th_party_connections_logs", 
        component: page("app/inputs/Integrations/Logs.vue"),
        meta: {
            title: "3th party connections logs"
        }
    },

    /**
     * Integrations
     */
    { path: "/app/integrations", name: "integrations", component: page("app/Integrations/apis.vue") },
    { path: "/app/integrations/:uuid/details", name: "integration_details", component: page("app/Integrations/DetailsPage.vue") },
    { path: "/app/integrations/apis/add", name: "add_integration", component: page("app/Integrations/api_config.vue") },
    { path: "/app/integrations/apis/edit", name: "edit_integration", component: page("app/Integrations/api_config.vue"), props: true },
    { path: "/app/integrations/facebook/callback", name: "integration_facebook_callback", component: page("app/Integrations/Facebook/callback.vue") },

    /**
     * Services
     */{ path: "/app/services/triggers/add", name: "add_trigger", component: page("app/Services/Triggers/trigger_config.vue") },
    
    { path: "/app/services/triggers/edit", name: "edit_trigger", component: page("app/Services/Triggers/trigger_config.vue"), props: true },
    { path: "/app/services/triggers", name: "triggers", component: page("app/Services/Triggers/triggers.vue") },
    { path: "/app/services/triggers/:trigger_uuid/feedback/logs", name: "trigger_feedback_logs", component: page("app/Services/Triggers/feedback_logs.vue") },
    { path: "/app/services/triggers/:trigger_uuid/leads", name: "trigger_leads", component: page("app/Services/Triggers/leads.vue") },
    { path: "/app/services/blacklist/emails", name: "emails_blacklist", component: page("app/Services/Blacklist/Pages/EmailsBlacklistPage.vue") },
    { path: "/app/services/blacklist/phones", name: "phones_blacklist", component: page("app/Services/Blacklist/Pages/PhonesBlacklistPage.vue") },
    { path: "/app/services/blacklist/badwords", name: "badwords_blacklist", component: page("app/Services/Blacklist/Pages/BadwordsBlacklistPage.vue") },
    { path: "/app/services/blacklist/domains", name: "domains_blacklist", component: page("app/Services/Blacklist/Pages/DomainsBlacklistPage.vue") },
    {
        path: "/app/services/throttling-service/throttling-deliveries",
        name: "throttling_deliveries",
        component: page("app/Services/ThrottlingDeliveries/Main.vue"),
    },

    {
        path: "/app/services/throttling-service/throttling-deliveries/:uuid/logs",
        name: "throttling_delivery_logs",
        component: page("app/Services/ThrottlingDeliveries/Logs.vue"),
    },



    { path: "/app/database", name: "database", component: page("app/db/database.vue"), meta: { roles: [] } },
    { path: "/app/database/view", name: "database_view", component: page("app/db/view.vue"), props: true },

    { path: "/app/campaings", name: "campaings", component: page("app/campaings/campaings.vue") },
    { path: "/app/campaigns/view", name: "view_campaign", component: page("app/campaings/view.vue"), props: true },
    { path: "/app/campaigns/:uuid/leads", name: "campaign_leads", component: page("app/campaings/leads.vue"), props: true },
    { 
        path: "/app/campaigns/:uuid/leads/:id", 
        name: "campaign_leads_details", 
        component: page("app/campaings/LeadDetails.vue"), 
        meta: {
            title: "Campaign leads details"
        },
        props: true 
    },
    { path: "/app/campaigns/:uuid/answers", name: "campaign_answers", component: page("app/campaings/Answers.vue"), props: true },
    { path: "/app/campaigns/inputs/:uuid/details", name: "input_campaign_details", component: page("app/campaings/Details.vue"), props: true },
    { path: "/app/campaigns/:provider/answers/:answer/values", name: "campaign_answer_values", component: page("app/campaings/AnswerValues.vue"), props: true },


    { path: "/app/inputs/providers", name: "providers", component: page("app/Providers/Main.vue") },
    { path: "/app/inputs/providers/add", name: "add_provider", component: page("app/Providers/View.vue") },
    { path: "/app/inputs/providers/edit", name: "edit_provider", component: page("app/Providers/View.vue") },


    /* Forms */
    { path: "/app/forms", name: "forms", component: page("app/forms/forms.vue"), meta: { roles: [] } },
    { path: "/app/forms/view", name: "view_forms", component: page("app/forms/view.vue"), props: true },
    { path: "/app/forms/form_preview/:uuid", name: "form_preview", component: page("app/forms/form_preview.vue"), props: true },
    { path: "/app/forms/download_step", name: "steps", component: page("app/forms/steps.vue"), props: true },
    { path: "/app/forms/stats", name: "FormStatsPage", component: page("app/forms/stats.vue"), props: true },

    /* Delivery campaigns */
    { path: "/app/delivery_campaings", name: "delivery_campaings", component: page("app/delivery_campaings/delivery_campaings.vue") },
    { path: "/app/delivery_campaings/view", name: "view_delivery_campaings", component: page("app/delivery_campaings/view.vue") },
    { path: "/app/delivery_campaings/:uuid/", name: "update_delivery_campaign", component: page("app/delivery_campaings/view.vue") },
    { path: "/app/delivery_campaings/:uuid/leads", name: "delivery_campaigns_leads", component: page("app/delivery_campaings/leads.vue") },
    { 
        path: "/app/delivery-campaings/:uuid/imports", 
        name: "delivery_campaigns_imports", 
        component: page("app/delivery_campaings/DeliveryCampaignImportsPage.vue"),
    },
    { 
        path: "/app/delivery-campaings/:uuid/imports/configuration",
        name: "delivery_campaigns_import_deliveries_configuration", 
        component: page("app/delivery_campaings/DeliveryCampaignImportDeliveriesConfigurationPage.vue"),
        props: true,
        meta: {
            title: "Configure import deliveries"
        }
    },
    { path: "/app/delivery_campaings/:uuid/details", name: "delivery_campaign_details", component: page("app/delivery_campaings/details.vue"), props: true },
    { path: "/app/delivery_campaings/:uuid/pendings", name: "delivery_pending", component: page("app/delivery_campaings/DeliveryPendingPage.vue"), props: true },
    { path: "/deliveries/:uuid/workflow/reports", name: "delivery_workflow_reports", component: page("app/delivery_campaings/WorkflowReportsPage.vue"), props: true },
    { path: "/app/delivery-campaigns/groups", name: "Delivery campaign groups", component: page("app/delivery_campaings/DeliveryCampaignGroupsPage.vue"), props: true },
    { path: "/app/delivery-campaigns/groups/create", name: "Create delivery campaign group", component: page("app/delivery_campaings/DeliveryCampaignGroupsCreatePage.vue"), props: true },
    { path: "/app/delivery-campaigns/groups/:uuid/update", name: "Update delivery campaign group", component: page("app/delivery_campaings/DeliveryCampaignGroupsUpdatePage.vue"), props: true },
    {
        path: "/app/delivery-campaigns/groups/:uuid/details", 
        name: "delivery_campaign_group_details", 
        component: page("app/delivery_campaings/DeliveryCampaignGroupDetailsPage.vue"), 
        props: true, 
        meta: {
            title: "Delivery campaign group details"
        }
    },
    {
        path: "/app/delivery-campaigns/groups/:uuid/logs",
        name: "delivery_campaign_group_logs",
        component: page("app/delivery_campaings/DeliveryCampaignGroupLogsPage.vue"),
        props: true,
        meta: {
            title: "Delivery campaign group logs"
        }
    },
    {
        path: "/app/delivery-campaigns/groups/:uuid/leads/:outcome",
        name: "delivery_campaign_group_leads_by_outcome",
        component: page("app/delivery_campaings/DeliveryCampaignGroupLeadsByOutcomePage.vue"),
        props: true,
        meta: {
            title: "Delivery campaign group leads by outcome"
        }
    },
    {
        path: "/app/delivery-campaigns/groups/:group/members/:member/leads", 
        name: "delivery_campaign_group_member_leads", 
        component: page("app/delivery_campaings/DeliveryCampaignGroupMemberLeadsPage.vue"), 
        props: true, 
        meta: {
            title: "Delivery campaign group member leads"
        }
    },
    {
        path: "/app/delivery-campaigns/groups/:group/members/:member/pendings", 
        name: "delivery_campaign_group_member_pendings", 
        component: page("app/delivery_campaings/DeliveryCampaignGroupMemberPendingsPage.vue"), 
        props: true, 
        meta: {
            title: "Delivery campaign group member pendings"
        }
    },

    /* Delivery by origins*/
    { path: "/app/delivery_by_origins", name: "delivery_origins", component: page("app/delivery_campaings/delivery_by_origins.vue") },

    /* Integration */
    { path: "/app/integration", name: "integration", component: page("app/integration/integration.vue") },
    { path: "/app/integration/log", name: "integration_log", component: page("app/integration/log.vue") },
    { path: "/app/integration/view", name: "view_integration", component: page("app/integration/v2/view.vue") },

    { 
        path: "/app/segments", 
        name: "segments", 
        component: page("app/Segments/Main.vue"),
        meta: {
            title: "Segments"
        } 
    },
    { 
        path: "/app/segments/create", 
        name: "create_segment", 
        component: page("app/Segments/View.vue"),
        meta: {
            title: "Create segment"
        }
    },
    { 
        path: "/app/segments/:uuid/edit", 
        name: "edit_segment",
        component: page("app/Segments/View.vue"),
        meta: {
            title: "Edit segment"
        }
    },

    /* Clients */
    { path: "/app/clients/", name: "clients", component: page("app/clients/clients.vue") },
    { path: "/app/clients/sponsors", name: "sponsors", component: page("app/clients/clients.vue") },
    { path: "/app/clients/coregisters", name: "coregisters", component: page("app/clients/clients.vue") },
    { path: "/app/clients/create", name: "create_client", component: page("app/clients/view.vue") },
    { path: "/app/clients/:uuid", name: "update_client", component: page("app/clients/view.vue") },

    { path: "/app/leads", name: "leads", component: page("app/leads/leads.vue") },

    /* Statistics */
    { path: "/app/statistics/crm", name: "crm", component: page("app/Statistics/Crm/View.vue"), meta: { title: "Brevo" } },
    { path: "/app/statistics/crm-sync", name: "crm-sync", component: page("app/Statistics/CrmSync/View.vue") },
    { path: "/app/statistics/logs", name: "logs", component: page("app/Statistics/Logs/View.vue") },

    /* Creativity */
    { path: "/app/creativity", name: "creativity", component: page("app/templates/creativity.vue"), meta: { roles: ["ADMIN_ROLE", "USER_ROLE"] } },
    { path: "/app/creativity/view", name: "view_creativity", component: page("app/templates/view.vue") },
    { path: "/app/creativity/:uuid", name: "update_creativity", component: page("app/templates/view.vue") },
    { path: "/app/creativity/:uuid/builder", name: "landing_builder", component: page("app/templates/landing_builder.vue") },
    { path: "/app/creativity/template_preview/:uuid", name: "template_preview", component: page("app/templates/template_preview.vue") },
    { path: "/app/templates/:uuid/steps", name: "template_steps", component: page("app/templates/steps.vue"), props: true },
    { path: "/app/templates/:templateId/steps/:stepId/builder", name: "step_builder", component: page("app/templates/step_builder.vue") },
    { path: "/app/templates/:uuid/steps/:stepId/config", name: "step_config", component: page("app/templates/step_config.vue"), props: true },

    /* Notifications */
    { path: "/app/notifications", name: "notifications", component: page("app/notifications/notifications.vue") },
    /* User */
    { path: "/user/profile", name: "profile", component: page("user/profile.vue") },
    { path: "/user/exports", name: "exports", component: page("user/Exports/Main.vue") },

    { path: "/user/billing-details", name: "billing_details", component: page("user/billing-details.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/app/subscription-plans", name: "subscription_plans", component: page("test/subscription.vue") },
    { path: "/user/app-access", name: "app_access", component: page("user/AppAccess.vue") },

    { path: "/app/users/activity", name: "users_activity", component: page("app/UsersManager/UsersActivity.vue"), meta: { roles: ["ADMIN_ROLE"] } },

    { path: "/app/documentation/headers", name: "headers", component: page("app/Documentation/Tags.vue") },
    { path: "/app/documentation/headers/subtag", name: "sub_tag", component: page("app/Documentation/SubTagView.vue") },
    { path: "/app/documentation/headers/fields", name: "tag_fields", component: page("app/Documentation/Fields.vue") },



    /** Routes defualt */

    { path: "/admin/langs", name: "langs", component: page("Admin/Langs/Manager.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/admin/headers/tags", name: "tags", component: page("Admin/Headers/Tags.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/admin/headers/tags/add", name: "add_tag", component: page("Admin/Headers/TagView.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/admin/headers/tags/edit", name: "edit_tag", component: page("Admin/Headers/TagView.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/admin/headers/fields", name: "fields", component: page("Admin/Headers/Fields.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/admin/headers/fields/add", name: "add_field", component: page("Admin/Headers/FieldView.vue"), meta: { roles: ["ADMIN_ROLE"] } },
    { path: "/admin/headers/fields/edit", name: "edit_field", component: page("Admin/Headers/FieldView.vue"), meta: { roles: ["ADMIN_ROLE"] } },

    { path: "*", component: page("errors/404.vue") }
];
